import {Directive, HostBinding, Input} from "@angular/core";

@Directive({selector: "tab"})
export class TabDirective {
	@Input() id: string;
	@Input() tabTitle: string;
	@Input() tabSubtitle: string;

	active: boolean;

	@HostBinding("style.display")
	get displayStyle() {
		return this.active ? null : "none";
	}
}
